import {useCallback} from 'react';

interface UseInfiniteScrollOptions {
	hasNextPage: boolean;
	onLoadMore: () => void;
	threshold?: number;
}

export const useInfiniteScroll = ({hasNextPage, onLoadMore, threshold = 100}: UseInfiniteScrollOptions) => {
	const handleScroll = useCallback(
		(e: React.UIEvent<HTMLElement>) => {
			const {scrollHeight, scrollTop, clientHeight} = e.currentTarget;
			if (hasNextPage && scrollHeight - scrollTop <= clientHeight + threshold) {
				onLoadMore();
			}
		},
		[hasNextPage, onLoadMore, threshold]
	);

	return {handleScroll};
};
